<template>
 <div class="container" style="max-width: 300px;">
    <b-form @submit="onSubmit">
      <b-form-group>
      <b-form-input
      id="input-username"
      v-model="form.username"
      type="email"
      required
      placeholder="Email"
      @input="status = true"
      ></b-form-input>
      
      <b-form-input
      id="input-password"
      v-model="form.password"
      type="password"
      required
      placeholder="Пароль"
      @input="status = true"
      ></b-form-input>
      </b-form-group>
      <b-button-group>
        <b-button type="submit" variant="primary" class="mx-2">Вход</b-button>
        <b-button @click="onRegistration" variant="light" class="mx-2">Регистрация</b-button>
      </b-button-group>
      <p class="mt-4 text-danger" v-if="!status">Не верные Email или пароль</p>
    </b-form>
  </div>     
</template>

<script>
/* eslint-disable no-console */
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  components: {
  },

  props: {
  },
  
  mixins: [],
  
  data () {
    return {
      form: {
          username: '',
          password: '',
        },
      status: true,
      }       
  },

  computed: {
    ...mapGetters([
    ]),
  },

  methods: {
    async onSubmit (evt){
      evt.preventDefault()
      this.status = await this.obtainToken(this.form)
      if (this.status) {
        document.location.reload(true);
        // this.$root.$emit('bv::hide::modal', 'login')
      }
    },
    
    onRegistration (evt){
      evt.preventDefault()
      console.log('Регистрация')
    },

    ...mapActions([
      'obtainToken',
      'inspectToken',
    ]),

  },

  mounted: function() {
    this.inspectToken()
  },


}

</script>

<style scoped>
</style>

